import {
  buildImageSrc,
  CROP_TYPES,
} from '@wix/communities-image-lib/dist/src/lib/media-server-client';

export const buildPlaceholderSrc = (file, w, h, props) =>
  buildImageSrc(file, w, h, { ...props, cropType: CROP_TYPES.FILL });
